'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Style


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementUtil = require('../elementUtil');

var _List = require('../../list/List');

var _List2 = _interopRequireDefault(_List);

var _EditableTitle = require('../../components/editableTitle/EditableTitle');

var _EditableTitle2 = _interopRequireDefault(_EditableTitle);

var _ColorBar = require('../../components/colors/ColorBar');

var _ColorBar2 = _interopRequireDefault(_ColorBar);

var _ElementUserTag = require('../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _ContainerElementChildCount = require('../containerElement/ContainerElementChildCount');

var _ContainerElementChildCount2 = _interopRequireDefault(_ContainerElementChildCount);

var _gridUtils = require('../../utils/grid/gridUtils');

var _columnConstants = require('../../../common/columns/columnConstants');

require('./Column.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = function Column(props) {
    var element = props.element,
        gridSize = props.gridSize,
        isSelected = props.isSelected,
        inList = props.inList,
        elementEvents = props.elementEvents;

    var colorName = element.get('content').get('color');

    var classes = (0, _elementUtil.elementClassNames)('Column drag-handle', props);

    return _react2.default.createElement(
        'div',
        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes,
            style: (0, _gridUtils.getElementStyle)(34, gridSize, inList) }, elementEvents),
        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
        _react2.default.createElement(_ElementUserTag2.default, props),
        _react2.default.createElement(_EditableTitle2.default, _extends({}, props, {
            elementId: element.get('id'),
            initialValue: 'New Column',
            selectFirst: true,
            selectAllOnEdit: true,
            isSelected: isSelected,
            editorKey: _columnConstants.COLUMN_TYPE })),
        _react2.default.createElement(_ContainerElementChildCount2.default, _extends({}, props, { show: true })),
        _react2.default.createElement(_List2.default, _extends({}, props, { listId: element.get('id') }))
    );
};

Column.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number,
    isSelected: _propTypes2.default.bool,
    inList: _propTypes2.default.string,
    className: _propTypes2.default.string,
    documentMode: _propTypes2.default.bool,
    elementEvents: _propTypes2.default.object
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/Column.js
// module id = 1962
// module chunks = 0